import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'age' })

export class AgePipe implements PipeTransform {
    transform(data: any) {
        if (data == null) return null;
        var birthdate = new Date(data);
        if (!(birthdate instanceof Date)) return data;
        
        var ageDifMillis = Date.now() - birthdate.getTime();
        var ageDate = new Date(ageDifMillis);

        return Math.abs(ageDate.getFullYear() - 1970);
    }
}